import { useQuery } from '@tanstack/react-query';
import { ActivityFeed, LogStats } from '../components/AgentLogs';
import { useLogs } from '../hooks';
import * as api from '../api';

export function ActivityPage() {
  const {
    logs,
    filters,
    loading,
    setWorkspaceFilter,
    setAgentFilter,
    setOperationFilter,
    clearFilters,
    exportLogs,
    refresh,
  } = useLogs();

  const statsQuery = useQuery({
    queryKey: ['logStats'],
    queryFn: api.getLogStats,
  });

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Activity</h1>
          <p className="mt-1 text-sm text-gray-500">
            Recent agent operations across all workspaces
          </p>
        </div>
      </div>

      {/* Stats Summary */}
      {statsQuery.data && <LogStats stats={statsQuery.data} />}

      {/* Activity Feed */}
      <ActivityFeed
        logs={logs}
        loading={loading}
        filters={filters}
        onFilterChange={(newFilters) => {
          if (newFilters.workspace !== filters.workspace) {
            setWorkspaceFilter(newFilters.workspace);
          }
          if (newFilters.agent !== filters.agent) {
            setAgentFilter(newFilters.agent);
          }
          if (newFilters.operation !== filters.operation) {
            setOperationFilter(newFilters.operation);
          }
          if (Object.keys(newFilters).length === 0) {
            clearFilters();
          }
        }}
        onRefresh={refresh}
        onExport={exportLogs}
      />
    </div>
  );
}
